import React from "react";
import TippyIcon from "../../TippyIcon";
import download from "../../../../assets/img/QuickActions/download.png";

const DownloadLeads = ({ onClick, className, disabled, style = {}, content, adminNoDownload = false }) => {
	const isDisabled = disabled || adminNoDownload;

	return (
		<TippyIcon
			content={
				content
					? (content === "Download"
						? (adminNoDownload
							? "Your role - Admin (No Downloads) doesn't have the necessary permission to download"
							: "Download")
						: "Delete")
					: null
			}
			placement="bottom"
		>
			<span>
				<img
					src={download}
					onClick={isDisabled ? undefined : onClick}
					className={className}
					style={{
						...style,
						opacity: isDisabled ? 0.5 : 1,
						pointerEvents: isDisabled ? "none" : "auto",
						cursor: isDisabled ? "not-allowed" : "pointer"
					}}
					alt="Download"
				/>
			</span>
		</TippyIcon>
	);
};

export default DownloadLeads;
